import { render, staticRenderFns } from "./JzList.vue?vue&type=template&id=500e5242&scoped=true&"
import script from "./JzList.vue?vue&type=script&lang=js&"
export * from "./JzList.vue?vue&type=script&lang=js&"
import style0 from "./JzList.vue?vue&type=style&index=0&id=500e5242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e5242",
  null
  
)

export default component.exports